<template>
    <div v-if="!hideProduct" class="relative flex flex-col border rounded-lg overflow-hidden shadow-md">
        <div v-if="showBanner" class="absolute right-0 top-0 h-16 w-16">
            <div class="absolute transform rotate-45 bg-green-600 text-center font-semibold text-sm py-1 right-[-35px] top-[32px] w-[170px] animate-pulse-scale">
                <span class="animate-text-flash">{{ remainingSpaces }} Spaces Left</span>
            </div>
        </div>
        <div class="aspect-w-16 aspect-h-9">
            <img :src="image" alt="Product Image" class="w-full h-full object-cover">
        </div>
        <div class="p-6 flex flex-col justify-between flex-grow">
            <div>
                <h2 class="text-xl font-bold mb-2 uppercase">{{ name }}</h2>
                <p v-html="description" class="text-gray-700 mb-4"></p>

                <div class="grid grid-cols-1 gap-3">
                    <div v-for="(item, key) in prices" :key="key"
                         class="flex items-center justify-between px-4 py-2 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                        <div class="flex items-center space-x-3">
                            <span class="text-gray-600">

                            <template v-if="key === 'car'">
                                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M5,11L6.5,6.5H17.5L19,11M17.5,16A1.5,1.5 0 0,1 16,14.5A1.5,1.5 0 0,1 17.5,13A1.5,1.5 0 0,1 19,14.5A1.5,1.5 0 0,1 17.5,16M6.5,16A1.5,1.5 0 0,1 5,14.5A1.5,1.5 0 0,1 6.5,13A1.5,1.5 0 0,1 8,14.5A1.5,1.5 0 0,1 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20A1,1 0 0,0 4,21H5A1,1 0 0,0 6,20V19H18V20A1,1 0 0,0 19,21H20A1,1 0 0,0 21,20V12L18.92,6Z"/>
                                </svg>
                            </template>
                            <template v-else-if="key === '4x4'">
                                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M5,13L6.5,8.5H17.5L19,13M17.5,18A1.5,1.5 0 0,1 16,16.5A1.5,1.5 0 0,1 17.5,15A1.5,1.5 0 0,1 19,16.5A1.5,1.5 0 0,1 17.5,18M6.5,18A1.5,1.5 0 0,1 5,16.5A1.5,1.5 0 0,1 6.5,15A1.5,1.5 0 0,1 8,16.5A1.5,1.5 0 0,1 6.5,18M18.92,8C18.72,7.42 18.16,7 17.5,7H6.5C5.84,7 5.28,7.42 5.08,8L3,14V20A1,1 0 0,0 4,21H5A1,1 0 0,0 6,20V19H18V20A1,1 0 0,0 19,21H20A1,1 0 0,0 21,20V14L18.92,8M8,6H16V4L19,7L16,10V8H8V10L5,7L8,4V6Z"/>
                                </svg>
                            </template>
                            <template v-else-if="key === 'van'">
                                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M17 5H3C1.89 5 1 5.89 1 7V17H3C3 18.66 4.34 20 6 20S9 18.66 9 17H15C15 18.66 16.34 20 18 20S21 18.66 21 17H23V12L17 5M17 7.76V10H13V7H16.24L17 7.76M6 18.5C5.17 18.5 4.5 17.83 4.5 17S5.17 15.5 6 15.5 7.5 16.17 7.5 17 6.83 18.5 6 18.5M18 18.5C17.17 18.5 16.5 17.83 16.5 17S17.17 15.5 18 15.5 19.5 16.17 19.5 17 18.83 18.5 18 18.5M8 10V7H11V10H8M3 10V7H6V10H3M13 12V15H11V12H13M3 12V15H11V12H3Z"/>
                                </svg>
                            </template>

                            </span>
                            <span class="font-medium text-gray-700 capitalize">{{ key }}</span>
                        </div>
                        <span class="text-lg font-semibold text-green-600">£{{ item.adjusted }}</span>
                    </div>
                </div>

                <p v-if="daysLeft >= 0" class="mt-4 text-red-500 font-bold">Limited time offer: {{ daysLeft }} days left</p>
            </div>
            <a :href="`/quick-booking/${id}`" class="mt-6 text-white bg-brand-blue text-sm px-4 py-2 font-bold rounded-lg text-center block hover:bg-opacity-90 transition-colors">Continue to Payment</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: Number,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        price: {
            type: Number,
            required: true,
        },
        start_ts: {
            type: String,
            required: false,
        },
        end_ts: {
            type: String,
            required: false,
        },
        prices: {
            type: Object,
            required: false,
        },
        operation: {
            type: String,
            required: false,
        },
        active: {
            type: Boolean,
            required: false,
        },
        current_per_day: {
            type: Number,
            required: false,
        },
        max_per_day: {
            type: Number,
            required: false,
        }
    },
    computed: {
        daysLeft() {
            if (this.start_ts && this.end_ts) {
                const endDate = new Date(this.end_ts);
                const currentDate = new Date();
                const timeDiff = endDate - currentDate;
                const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
                return daysLeft >= 0 ? daysLeft : -1;
            }
            return -1;
        },
        hideProduct() {
            return this.active === false || (this.max_per_day !== null && this.current_per_day >= this.max_per_day) || (this.start_ts && this.end_ts && this.daysLeft < 0);
        },
        showBanner() {
            return this.max_per_day > 0;
        },

        remainingSpaces() {
            return this.max_per_day - this.current_per_day;
        }
    }
};
</script>
